import { Box } from '@chakra-ui/react'
import { useColorMode } from 'uikit/ColorMode/ColorMode'

export const RightAside = ({ children, ...props }) => {
  const { colorMode } = useColorMode()
  const themeBgContainer = colorMode === 'light' ? 'white' : 'gray.700'
  const themeBorderWidth = colorMode === 'light' ? '1px' : 'none'
  
  return (
    <Box
      borderWidth={themeBorderWidth}
      padding={4}
      borderRadius={6}
      borderColor="gray.200"
      //position="sticky"
      background={themeBgContainer}
      top="0"
      mt="0"
      {...props}
    >
      {children}
    </Box>
  )
}
